var _path, _path2, _path3, _path4, _g, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _circle, _circle2, _circle3, _circle4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _ellipse5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinionConfused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 691,
    viewBox: "0 0 423 691",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.758 607.894L221.852 596.37L257.972 599.89L255.158 616.123C261.27 625.794 263.375 643.04 257.507 647.642C251.638 652.243 225.321 646.722 218.892 641.907C212.463 637.092 210.854 629.847 212.009 621.526C212.826 615.643 218.758 607.894 218.758 607.894Z",
    fill: "#232631"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.604 584.266L135.413 564.115L169.47 573.636C169.47 573.636 170.412 579.017 171.32 582.392C173.161 589.235 178.783 596.06 177.94 599.287C177.098 602.514 166.883 604.674 158.435 607.984C149.988 611.294 141.342 621.734 128.181 623.525C117.776 624.941 103.598 622.623 101.522 620.013C99.4455 617.403 100.205 606.571 101.047 603.344C101.89 600.116 117.818 587.309 133.604 584.266Z",
    fill: "#232631"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.89 245.944C151.462 271.756 112.801 472.964 112.801 472.964L110.828 503.322L141.707 537.868L292.471 586.068L313.739 576.254L321.241 559.816C308.209 539.329 418.069 383.484 378.906 305.015C358.893 264.916 276.627 231.231 227.89 245.944Z",
    fill: "#FDDB44"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_543_49",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 242,
    width: 278,
    height: 345
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.89 245.944C151.462 271.756 112.801 472.964 112.801 472.964L110.828 503.322L141.707 537.868L292.471 586.068L318.061 577.414L324.32 548.281C311.288 527.793 418.069 383.484 378.906 305.015C358.893 264.916 276.627 231.231 227.89 245.944Z",
    fill: "#FDDB44"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_543_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.937 283.811C330.137 256.335 297.604 233.7 297.604 233.7L344.408 226.19L396.884 329.853L361.609 507.253L313.739 576.253L251.997 610.641L105.275 558.893L85.6795 499.578L135.175 378.505C135.175 378.505 135.309 412.517 154.703 420.813C174.097 429.109 251.954 467.001 269.84 457.904C287.726 448.807 327.738 311.288 328.937 283.811Z",
    fill: "#FCB537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.492 430.816C250.757 433.478 241.2 429.084 227.115 425.193C213.03 421.301 200.191 416.006 200.927 413.345C201.662 410.683 219.454 405.798 233.539 409.69C247.624 413.581 252.227 428.155 251.492 430.816Z",
    fill: "#352121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.595 427.926L217.563 422.388C217.563 422.388 224.755 416.91 229.664 420.047C234.573 423.184 236.595 427.926 236.595 427.926Z",
    fill: "#EB4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.168 412.048L225.164 408.048C232.7 409.1 236.235 410.06 239.168 412.048L236.667 416.548L223.168 412.048Z",
    fill: "#F5F5E7"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.546 401.164C128.954 398.073 132.361 394.735 132.361 394.735L130.427 401.938C129.653 404.819 142.579 431.455 145.74 436.937C148.901 442.419 264.705 482.778 276.616 484.431C288.528 486.085 346.469 483.109 346.469 483.109L350.23 474.852C350.23 474.852 352.38 478.93 353.005 481.775C354.753 489.74 349.417 500.889 347.59 501.943L340.281 506.158C340.281 506.158 288.488 509.24 281.459 518.164C274.43 527.087 269.296 551.963 272.35 563.594C275.405 575.225 316.134 572.261 313.739 576.251C311.344 580.241 284.827 602.068 264.402 604.703C237.205 608.212 211.255 601.019 179.303 588.032C149.781 576.033 133.699 568.066 122.281 558.823C110.863 549.58 107.809 537.949 107.742 520.943C107.674 503.936 127.641 458.332 127.641 458.332C127.641 458.332 118.581 439.043 119.53 425.267C120.17 415.969 123.785 409.421 127.546 401.164Z",
    fill: "#27456A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.516 453.663C150.236 448.955 145.073 433.669 145.073 433.669L284.206 484.925C284.206 484.925 264.986 487.486 259.504 490.647C254.022 493.809 236.404 570.931 230.535 575.533C224.667 580.135 206.713 572.226 182.611 564.21C161.804 557.291 129.03 545.191 124.922 531.733C120.813 518.275 150.796 458.372 150.516 453.663Z",
    fill: "url(#paint0_linear_543_49)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.227,
    cy: 322.309,
    rx: 41.7638,
    ry: 44.7671,
    transform: "rotate(15.0289 201.227 322.309)",
    fill: "#CBBED8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.879,
    cy: 327.989,
    rx: 35.7975,
    ry: 37.2891,
    transform: "rotate(15.0289 205.879 327.989)",
    fill: "#FDFEF9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.984,
    cy: 354.463,
    rx: 43.2553,
    ry: 46.2384,
    transform: "rotate(15.0289 292.984 354.463)",
    fill: "#CBBED8"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.758,
    cy: 361.385,
    rx: 38.7806,
    ry: 40.2722,
    transform: "rotate(15.0289 295.758 361.385)",
    fill: "#FDFEF9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 197.005,
    cy: 311.053,
    r: 23.865,
    transform: "rotate(15.0289 197.005 311.053)",
    fill: "#0D071D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.01,
    cy: 336.053,
    r: 23.865,
    transform: "rotate(15.0289 288.01 336.053)",
    fill: "#0D071D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.336,
    cy: 297.981,
    r: 5.96625,
    transform: "rotate(15.0289 194.336 297.981)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 281.687,
    cy: 325.089,
    r: 5.96625,
    transform: "rotate(15.0289 281.687 325.089)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M193.91 322.577C190.062 321.268 187.754 316.012 186.55 312.176C185.877 310.035 183.52 308.744 181.436 309.579C179.789 310.24 178.894 312.012 179.478 313.687C181.173 318.548 185.24 327.886 191.976 329.78C199.15 331.796 207.367 324.848 210.243 322.122C210.912 321.487 211.119 320.525 210.824 319.652C210.242 317.927 208.04 317.341 206.572 318.416C203.288 320.823 197.957 323.954 193.91 322.577Z",
    fill: "url(#paint1_linear_543_49)",
    stroke: "black",
    strokeWidth: 2.50723
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M284.527 349.018C280.759 347.736 278.326 343.195 276.991 339.8C276.188 337.76 273.876 336.575 271.842 337.39C270.116 338.082 269.219 339.976 269.933 341.693C271.821 346.232 276.044 354.379 282.594 356.22C289.637 358.2 297.442 352.447 300.354 349.997C301.095 349.374 301.336 348.366 301.027 347.45L300.967 347.273C300.408 345.617 298.342 344.992 296.858 345.915C293.682 347.89 288.55 350.386 284.527 349.018Z",
    fill: "url(#paint2_linear_543_49)",
    stroke: "black",
    strokeWidth: 2.50723
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.816 375.405C208.299 397.361 170.578 390.942 155.874 353.173C194.192 376.812 211.202 373.599 237.638 353.504C237.638 353.504 249.47 401.468 285.59 404.988C321.71 408.509 331.167 384.793 331.167 384.793L345.572 388.661C345.572 388.661 345.168 391.635 327.13 409.189C309.093 426.743 257.451 421.368 235.816 375.405Z",
    fill: "#F9A831"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M372.986 372.854L346.602 350.326L328.957 387.287L358.715 402.999L372.986 372.854Z",
    fill: "#13152C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.349 273.434C239.343 280.144 254.386 307.217 247.083 334.419C239.779 361.62 213.199 377.518 188.205 370.807C163.212 364.097 148.169 337.024 155.472 309.822C162.775 282.621 189.356 266.723 214.349 273.434Z",
    stroke: "url(#paint3_linear_543_49)",
    strokeWidth: 12.5361
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M306.442 304.336C332.384 311.301 347.877 338.665 340.617 365.708C333.356 392.75 306.24 408.674 280.298 401.709C254.356 394.744 238.864 367.379 246.124 340.337C253.385 313.295 280.5 297.37 306.442 304.336Z",
    stroke: "url(#paint4_linear_543_49)",
    strokeWidth: 12.5361
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M403.866 407.399C407.63 394.384 410.934 375.321 397.969 371.84C385.004 368.359 384.511 375.948 384.511 375.948L368.306 413.296C368.306 413.296 373.748 433.29 381.338 433.783C388.927 434.276 400.247 419.912 403.866 407.399Z",
    fill: "#FAFBF6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M385.112 362.21C395.66 365.409 399.41 372.226 399.41 372.226C399.41 372.226 386.619 379.603 379.764 399.384C370.972 424.752 381.339 433.783 381.339 433.783C381.339 433.783 375.586 434.721 371.922 434.344C366.099 433.744 357.903 429.035 357.903 429.035C357.903 429.035 347.926 420.179 360.37 391.088C372.814 361.997 385.112 362.21 385.112 362.21Z",
    fill: "#252644"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M320.919 538.031C320.919 538.031 303.179 517.824 305.78 513.89C308.381 509.955 329.428 506.339 333.75 507.5C338.072 508.66 346.849 544.993 344.529 553.637L344.529 553.637C342.208 562.28 341.821 563.72 336.339 566.882C330.857 570.043 282.719 571.018 282.719 571.018L284.693 540.66L320.919 538.031Z",
    fill: "#FDDB44"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7808 449.42C79.4855 457.68 113.383 469.567 115.267 466.815C117.151 464.063 118.459 447.982 116.286 444.07C114.114 440.158 94.1213 441.023 94.1213 441.023L97.1651 434.214L71.0914 417.983C71.0914 417.983 60.076 441.16 69.7808 449.42Z",
    fill: "#FDDB44"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M298.605 552.118C298.044 542.701 291.721 531.737 287.013 532.017C282.305 532.297 280.352 534.687 280.352 534.687C280.352 534.687 276.929 529.31 263.578 527.269C250.226 525.229 234.94 530.391 234.94 530.391C228.674 537.222 227.7 541.153 233.18 548.451C231.568 553.042 231.461 555.769 235.848 561.523C235.07 569.247 236.658 571.156 240.344 573.54C240.344 573.54 261.005 571.366 264.272 570.699C267.54 570.032 272.635 568.311 272.635 568.311C272.635 568.311 283.773 572.846 287.041 572.179C290.309 571.511 299.165 561.534 298.605 552.118Z",
    fill: "#2A2B47"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M168.862 469.843L230.583 490.748C233.812 491.842 235.575 495.317 234.551 498.57L222.179 537.83C221.122 541.182 217.518 543.011 214.19 541.883L152.468 520.978C149.239 519.884 147.476 516.408 148.501 513.156L160.873 473.895C161.929 470.544 165.533 468.715 168.862 469.843Z",
    fill: "url(#paint5_radial_543_49)",
    stroke: "#2D3F66",
    strokeWidth: 7.52169
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M153.094 543.591L143.211 540.034C141.393 539.38 140.379 537.441 140.881 535.574C141.444 533.475 143.682 532.305 145.728 533.041L155.61 536.598C157.429 537.252 158.442 539.191 157.941 541.058C157.377 543.158 155.139 544.327 153.094 543.591Z",
    fill: "#2B3956"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M178.475 553.622L168.485 550.38C166.647 549.783 165.572 547.877 166.014 545.996C166.511 543.879 168.711 542.64 170.779 543.311L180.769 546.552C182.607 547.149 183.681 549.055 183.24 550.937C182.743 553.053 180.543 554.293 178.475 553.622Z",
    fill: "#2B3956"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M207.754 561.739L197.556 559.225C195.68 558.763 194.471 556.939 194.776 555.03C195.12 552.884 197.224 551.489 199.335 552.009L209.533 554.523C211.409 554.986 212.618 556.81 212.313 558.718C211.969 560.865 209.865 562.26 207.754 561.739Z",
    fill: "#2B3956"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M389.621 403.575C390.395 400.693 397.917 384.18 402.239 385.341C406.56 386.501 402.693 400.907 401.532 405.228C400.372 409.55 395.064 423.568 389.302 422.021C384.269 420.67 387.681 409.805 389.141 405.156C389.353 404.482 389.523 403.939 389.621 403.575Z",
    fill: "#2F3451"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.498 355.891L133.868 412.128L128.213 404.432L150.562 343.487L156.498 355.891Z",
    fill: "#FFEEA1",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.278 432.023L339.938 484.443L346.473 483.109L369.041 433.57L363.278 432.023Z",
    fill: "#FFEEA1",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M296.95 564.029L292.135 570.458L321.826 569.163C321.757 570.306 334.514 567.398 338.165 565.828C341.817 564.258 345.215 552.593 345.301 550.756C343.61 533.774 341.516 524.376 335.189 507.887L329.04 507.78C329.04 507.78 342.807 548.542 342.033 551.423C341.26 554.304 339.712 560.066 337.498 562.56C335.284 565.055 296.95 564.029 296.95 564.029Z",
    fill: "#FFFF95"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M121.561 606.636C114.312 608.951 110.761 608.621 105.733 603.883C106.525 599.685 108.367 597.301 114.098 592.968C116.426 594.776 119.267 595.554 127.006 596.338C126.852 600.369 125.455 602.623 121.561 606.636Z",
    fill: "#636E8A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M120.079 606.949C119.492 614.72 120.308 618.327 124.931 622.693C139.709 620.932 147.78 618.172 161.64 608.836C170.402 606.295 174.955 604.716 179.686 600.449C178.627 593.199 177.494 589.333 171.606 583.862C162.578 586.847 157.369 587.547 147.64 585.879C139.475 591.353 134.365 594.083 122.606 597.268C123.142 601.268 122.81 603.419 120.079 606.949Z",
    fill: "#333F59"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M222.867 621.358C219.322 617.16 218.759 607.9 218.759 607.9C218.759 607.9 214.623 613.226 213.17 617.21C211.561 621.622 210.705 624.496 211.516 629.122C212.586 635.22 214.162 641.793 220.333 642.3C227.514 642.889 229.296 626.173 229.296 626.173C229.296 626.173 224.891 623.755 222.867 621.358Z",
    fill: "#333F59"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M241.492 632.536C236.336 631.033 228.002 631.385 229.3 626.174C229.745 624.387 230.467 623.395 231.901 622.239C236.007 618.928 239.215 626.824 244.479 627.161C247.61 627.36 249.42 625.423 252.455 626.213C256.237 627.198 258.767 629.128 259.938 632.856C262.098 639.729 248.409 634.552 241.492 632.536Z",
    fill: "#636E8A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M109.29 223.896C109.223 223.897 108.237 224.037 106.417 224.615C102.658 225.808 101.521 230.806 96.4411 250.113C92.6156 264.654 95.6578 281.152 97.2201 285.829C98.6218 290.025 102.008 292.984 122.998 307.808C134.401 315.863 137.521 324.449 139.135 330.749C141.337 339.345 137.12 344.662 124.608 361.407C109.859 381.146 101.774 386.73 99.4751 395.107C93.838 415.651 98.3155 424.375 102.133 434.403C106.583 446.095 114.965 456.506 120.802 463.919C124.491 469.675 127.263 477.345 129.69 487.257C130.664 492.008 131.118 496.19 130.476 501.319",
    stroke: "white",
    strokeWidth: 1.4464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7744 400.384C72.6419 403.009 68.3438 415.006 72.2804 424.204C76.2171 433.403 83.8359 435.947 83.8359 435.947C90.4885 437.393 94.1729 437.366 100.479 432.452C104.215 433.028 121.675 432.814 124.568 429.4C127.46 425.985 125.262 418.195 123.523 416.786C121.784 415.378 128.518 413.198 127.031 408.03C125.545 402.861 120.203 402.245 120.203 402.245C121.361 395.996 121.309 393.779 115.918 388.842C115.918 388.842 105.407 389.712 98.136 391.373C90.8652 393.033 84.9069 397.76 78.7744 400.384Z",
    fill: "#2A2B47"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.2758,
    cy: 121.764,
    rx: 92.5002,
    ry: 112.721,
    transform: "rotate(-1.21091 96.2758 121.764)",
    fill: "url(#paint6_radial_543_49)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_543_49",
    x1: 216.38,
    y1: 452.815,
    x2: 185.673,
    y2: 567.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFBCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53657D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_543_49",
    x1: 210.336,
    y1: 324.671,
    x2: 177.204,
    y2: 315.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#2778DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C0522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_543_49",
    x1: 300.567,
    y1: 352.552,
    x2: 267.434,
    y2: 343.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#440623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#2778DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C0522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_543_49",
    x1: 215.975,
    y1: 267.38,
    x2: 186.58,
    y2: 376.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#323D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_543_49",
    x1: 308.068,
    y1: 298.281,
    x2: 278.673,
    y2: 407.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.408654,
    stopColor: "#323D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980C3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_543_49",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.526 505.863) rotate(104.698) scale(33.5602 44.0011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111022"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_543_49",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.0103 93.24) rotate(65.5349) scale(155.178 127.341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B1A1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinionConfused);
export default __webpack_public_path__ + "static/media/minion-confused.5e5cf0803ea665fc61ee8022e1b027d9.svg";
export { ForwardRef as ReactComponent };